import { environment } from '../environments/environment';

export function log(
    title: any = '',
    message: any = '',
    message2: any = '',
    message3: any = '',
    message4: any = ''
): void {
  if (!environment.production) {
    console.log(title, message, message2, message3, message4);
  }
}
export function error(
    title: any = '',
    message: any = '',
    message2: any = '',
    message3: any = '',
    message4: any = ''
): void {
  if (!environment.production) {
    console.error(title, message, message2, message3, message4);
  }
}
export function isMobile(): boolean {
  return window.innerWidth < 768;
}

export function calcDiv (val, by) {
  return (val - (val % by)) / by;
}